module.exports = __webpack_public_path__ + "static/backgr-2e9681a0cb4b46c0d3636431d9095500.png";